<script>
    import { onMount } from "svelte";

    import {
        PageHead,
        PageLoading,
        Notes,
    } from "../../Components/Common/index.svelte";

    import { insuranceFund } from "../../stores";

    import { apiMethods } from "../../Services/index.svelte";

    import PatientDetails from "./components/PatientDetails.svelte";
    import PatientAlertsAndDocuments from "./components/PatientAlertsAndDocuments.svelte";
    import PatientContactsDetails from "./components/PatientContactsDetails.svelte";

    import { showError } from "../../Utils/utilFunctions.svelte";

    import { cacheInsuranceFunds } from "../../Utils/utilCache.svelte";
    import { NoteTypes } from "../../Utils/utilConstants.svelte";

    export let params;

    let isGettingPatient = false,
        patientDetail = {},
        patientContacts = [];

    onMount(() => {
        if (params.id) getPatient(params.id);
    });

    const getPatient = async (id) => {
        isGettingPatient = true;

        await apiMethods.getMethod
            .getPatientById(id)
            .then((res) => _handlePatient(res))
            .catch((err) => showException(err));

        isGettingPatient = false;
    };

    const reloadPatient = async () => {
        await apiMethods.getMethod
            .getPatientById(params.id)
            .then((res) => _handlePatient(res));
    };

    const reloadPatientContacts = async () => {
        await apiMethods.getMethod
            .getPatientById(params.id)
            .then((res) => _handlePatientContacts(res.patientContacts))
            .catch((err) => showException(err));
    };

    const syncPatientFiles = async () => {
        await apiMethods.getMethod.getPatientById(params.id).then((res) => {
            if (res.id) patientDetail = { ...res };
        });
    };

    // HELPER FUNCTIONS
    const _handlePatient = async (res) => {
        if (!res || res.error)
            showError(
                "Failed to load patient details, please refresh the page and try again and contact support if the issue persists.",
            );
        else {
            patientDetail = { ...res };

            if (patientDetail.insuranceId) {
                await cacheInsuranceFunds();

                patientDetail.insuranceFundName = $insuranceFund.find(
                    (insuranceFund) =>
                        insuranceFund.id == patientDetail.insuranceId,
                ).name;
            }

            if (res.patientContacts.length)
                _handlePatientContacts(res.patientContacts);
        }
    };

    const _handlePatientContacts = (contacts) => {
        patientContacts = contacts;
        patientDetail.patientContacts = contacts;
    };
</script>

<PageHead title="View Patient Details" />

{#if isGettingPatient}
    <PageLoading />
{:else}
    <div class="flex-1 relative mt-4">
        <div class="flex flex-col overflow-y-auto absolute inset-0 gap-4 px-2">
            <PatientDetails {patientDetail} loadData={reloadPatient} />

            <PatientAlertsAndDocuments {patientDetail} {syncPatientFiles} />

            <Notes
                noteOwnerID={patientDetail.id}
                noteType={NoteTypes.Patient}
                hasNotes={patientDetail.hasNotes}
                onFinishModifyNote={reloadPatient}
            />

            <PatientContactsDetails
                patientID={patientDetail.id}
                {patientContacts}
                {reloadPatientContacts}
            />
        </div>
    </div>
{/if}
